import React, { useEffect, useRef, useState } from "react";
import { Grid, Layout } from "antd";
import SettingSidebar from "./SettingSidebar";
import SettingsRightSection from "./SettingsRightSection";
import { useSettingSidebarContext } from "../../context/SettingSidebarScreenContext";
import { HomePhoneProduct } from "../../types/homePhone";
import "./index.scss";

const { useBreakpoint } = Grid;

const SettingsLayout = () => {
  const { settingsCurrentScreen } = useSettingSidebarContext();
  const screens = useBreakpoint();
  const isMobile = !screens.md; // true when width < 768px

  const [selectedHomePhoneProduct, setSelectedHomePhoneProduct] =
    useState<HomePhoneProduct | null>(null);
  const [rightView, setRightView] = useState<"home-phone" | "my-device">(
    "home-phone",
  );

  const prevScreen = useRef(settingsCurrentScreen);

  useEffect(() => {
    const from = prevScreen.current;
    const to = settingsCurrentScreen;
    prevScreen.current = to;

    if (from === "subscription" && to === "main") {
      // User pressed back in the subscription header — clear the detail panel
      setSelectedHomePhoneProduct(null);
      setRightView("home-phone");
    } else if (to !== "main" && to !== "subscription") {
      setRightView("home-phone");
    }
  }, [settingsCurrentScreen]);

  const isOnContentScreen =
    settingsCurrentScreen === "main" || settingsCurrentScreen === "subscription";

  // On mobile: only show right section when there is actual content to display
  const showRightSection =
    isOnContentScreen &&
    (!isMobile || selectedHomePhoneProduct !== null || rightView === "my-device");

  return (
    <Layout className="settings-layout">
      <SettingSidebar
        selectedHomePhoneProductId={selectedHomePhoneProduct?.id}
        onHomePhoneProductSelect={(product) => {
          setSelectedHomePhoneProduct(product);
          setRightView("home-phone");
        }}
        onOpenMyDevice={() => setRightView("my-device")}
      />
      {showRightSection && (
        <SettingsRightSection
          rightView={rightView}
          homePhoneProduct={selectedHomePhoneProduct}
          onOpenHomePhone={() => setRightView("home-phone")}
          onOpenMyDevice={() => setRightView("my-device")}
        />
      )}
    </Layout>
  );
};

export default SettingsLayout;
